import { US_STATES } from '@nesso/common-contracts/us-states';

const CODE_BY_NAME: Map<string, string> = new Map(US_STATES.map(([code, name]) => [name, code]));

/** "Illinois" → "IL" — addresses store `state` as the full name; this derives the two-letter code
 * for compact display. */
export function getStateCode(stateName: string): string {
    return CODE_BY_NAME.get(stateName) ?? stateName;
}
